import React, { useState } from 'react';

/*import {
    Chart as ChartJS,
    ArcElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    LineController, DoughnutController, PieController
} from "chart.js";*/
import 'chart.js/auto';
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart } from "react-chartjs-2";

import * as commonFunc from 'scripts/common';

//Déclaration pour optimisation taille bundle >> sinon utiliser chart.js/auto
//ChartJS.register(ArcElement, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler, LineController, DoughnutController, PieController);

const CChart = React.forwardRef((props, ref) => {
    const [chartData, setChartData] = useState(props.data);

    React.useEffect(() => {
        const chartElement = ref ? ref.current : null;
        if (chartElement && props.type === "line" && props.subtype === "gradient") {
            var componentProps = props.data;
            componentProps.datasets = componentProps.datasets ? componentProps.datasets.map((dataset) => ({
                ...dataset,
                tension: 0.4,//arrondi lignes
                pointRadius: 0,
                borderWidth: 4,
                borderColor: dataset.color,
                fill: true,
                maxBarThickness: 6,
                backgroundColor: gradientChartLine(
                    chartElement.ctx,
                    dataset.color
                ),
            })) : [];

            setChartData(componentProps);
        }
        else {
            setChartData(props.data);
        }
    }, [props.data]);

    //Gestion de l'affichage footer tooltip si présent
    const sumFooter = (tooltipItems) => {
        var sum = 0;

        tooltipItems.forEach(function (tooltipItem) {
            if (!props.options?.plugins?.tooltip?.callbacks?.footerFilter || props.options?.plugins.tooltip.callbacks.footerFilter.indexOf(tooltipItem.dataset.cTarget) >= 0) {
                sum += parseFloat(tooltipItem.raw);
            }
        });
        return (props.options?.plugins?.tooltip?.callbacks?.footerLabel ? props.options?.plugins.tooltip.callbacks.footerLabel : 'Somme') + ' : ' + sum.toFixed(2);
    };
    const sumFooterX = (tooltipItems) => {
        var sum = 0;

        tooltipItems.forEach(function (tooltipItem) {
            if (!props.options?.plugins?.tooltip?.callbacks?.footerFilter || props.options?.plugins.tooltip.callbacks.footerFilter.indexOf(tooltipItem.dataset.cTarget) >= 0) {
                sum += parseFloat(tooltipItem.raw);
            }
        });
        return (props.options?.plugins?.tooltip?.callbacks?.footerLabel ? props.options?.plugins.tooltip.callbacks.footerLabel : 'Somme') + ' : ' + sum.toFixed(2);
    };
    const difFooterClassic = (tooltipItems) => {
        var dif = 0;

        tooltipItems.forEach(function (tooltipItem) {
            if (!tooltipItem.dataset.avoidFooter) {
                if (dif) dif -= tooltipItem.raw;
                else dif = tooltipItem.raw;
            }
        });
        return 'Écart : ' + dif.toFixed(2);
    };
    const difFooter = (tooltipItems) => {
        var dif = 0;
        var difPct = 0;

        tooltipItems.forEach(function (tooltipItem) {
            if (!tooltipItem.dataset.avoidFooter) {
                if (dif) {
                    difPct = (((dif - tooltipItem.raw) / tooltipItem.raw) * 100).toFixed(2);
                    dif -= tooltipItem.raw;
                }
                else dif = tooltipItem.raw;
            }
        });
        return 'Écart : ' + dif?.toFixed(2) + '\nÉcart (%) : ' + (difPct > 100 ? 100 : difPct) + ' %';
    };
    const difFooterReverse = (tooltipItems) => {
        var dif = 0;

        tooltipItems.reverse().forEach(function (tooltipItem) {
            if (!tooltipItem.dataset.avoidFooter) {
                if (dif) dif -= tooltipItem.raw;
                else dif = tooltipItem.raw;
            }
        });
        return 'Écart : ' + dif.toFixed(2);
    };
    const difFooterReversePct = (tooltipItems) => {
        var dif = 0;
        var difPct = 0;

        tooltipItems.reverse().forEach(function (tooltipItem) {
            if (!tooltipItem.dataset.avoidFooter) {
                if (dif) {
                    difPct = (((dif - tooltipItem.raw) / tooltipItem.raw) * 100).toFixed(2);
                    dif -= tooltipItem.raw;
                }
                else dif = tooltipItem.raw;
            }
        });
        return 'Écart : ' + dif?.toFixed(2) + '\nÉcart (%) : ' + (difPct > 100 ? 100 : difPct) + ' %';
    };
    if (props.options?.plugins?.tooltip?.callbacks?.footer) {
        switch (props.options.plugins.tooltip.callbacks.footer) {
            case "sumFooter": props.options.plugins.tooltip.callbacks.footer = sumFooter; break;
            case "sumFooterX": props.options.plugins.tooltip.callbacks.footer = sumFooterX; break;
            case "difFooterClassic": props.options.plugins.tooltip.callbacks.footer = difFooterClassic; break;
            case "difFooter": props.options.plugins.tooltip.callbacks.footer = difFooter; break;
            case "difFooterReverse": props.options.plugins.tooltip.callbacks.footer = difFooterReverse; break;
            case "difFooterReversePct": props.options.plugins.tooltip.callbacks.footer = difFooterReversePct; break;
            default: break;
        }
    }


    var tempID = parseInt(Math.floor(Date.now() + Math.random() * 1000000000000001).toString().substring(6));

    var supProps = {};
    if (props.useLabelPlugin) supProps.plugins = [ChartDataLabels];

    return <div className={props.className} style={{ width: props.width, height: props.height, ...props.style }}>
        <Chart key={tempID} ref={ref} {...props} data={chartData} { ...supProps} />
    </div>;
});

// Setting default values for the props of CChart
CChart.defaultProps = {
    width: "150px",
    height: "150px",
};

export default CChart;



function gradientChartLine(chart, color, opacity = 0.2) {
    const gradientStroke = chart.createLinearGradient(0, 230, 0, 50);
    const primaryColor = `rgba(${commonFunc.hexToRgb(color)}, ${opacity})`;

    gradientStroke.addColorStop(1, primaryColor);
    gradientStroke.addColorStop(0.2, "rgba(72, 72, 176, 0.0)");
    gradientStroke.addColorStop(0, "rgba(203, 12, 159, 0)");

    return gradientStroke;
}